import TableRef from './TableRef';

class TableColumns {
  constructor(tableRef, columns) {
    this._tableRef = tableRef; // TableRef
    this._columns = columns.map((c) => c); // list of strings
  }

  static buildFromServer(obj) {
    return new TableColumns(
      new TableRef(obj._table._schema, obj._table._name),
      obj._columnNames,
    );
  }

  tableRef() {
    return this._tableRef;
  }

  columns() {
    return this._columns;
  }
}

export default TableColumns;
